import { hotRank } from "@/mocks/headlines";

const sections = [
  { icon: "ri-focus-3-line", name: "深挖追踪", count: "128 篇", tone: "text-primary-600 bg-primary-100" },
  { icon: "ri-chat-check-line", name: "实锤讨论", count: "86 帖", tone: "text-accent-700 bg-accent-100" },
  { icon: "ri-route-line", name: "时间线对齐", count: "54 条", tone: "text-secondary-700 bg-secondary-200" },
  { icon: "ri-arrow-left-right-line", name: "反转复盘", count: "31 篇", tone: "text-primary-600 bg-primary-100" },
  { icon: "ri-restart-line", name: "后续进展", count: "72 条", tone: "text-accent-700 bg-accent-100" },
  { icon: "ri-folder-chart-line", name: "专题合集", count: "19 册", tone: "text-secondary-700 bg-secondary-200" },
];

export default function HotRankSection() {
  return (
    <section id="hotrank" className="scroll-mt-28 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-3">
          {/* 热榜 */}
          <div className="border border-background-200 bg-background-50 p-5 lg:col-span-2">
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="h-5 w-1 bg-accent-500" />
                <h2 className="font-heading text-xl font-bold text-foreground-950">全网热榜</h2>
                <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 text-[11px] font-medium text-accent-900">
                  实时
                </span>
              </div>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-arrow-up-down-line" /> 热度按讨论量排序
              </span>
            </div>
            <ol className="flex flex-col gap-1">
              {hotRank.map((h) => (
                <li key={h.id}>
                  <a
                    href="#discussion"
                    className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex w-6 shrink-0 items-center justify-center font-heading text-lg font-bold ${
                        h.id <= 3 ? "text-primary-500" : "text-foreground-400"
                      }`}
                    >
                      {String(h.id).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-foreground-950">
                        {h.title}
                      </p>
                      <p className="mt-0.5 text-[11px] text-foreground-500">
                        <span className="rounded-sm bg-secondary-100 px-1 py-px text-secondary-800">{h.tag}</span>
                      </p>
                    </div>
                    <span className="flex shrink-0 flex-col items-end">
                      <b className="text-sm font-semibold text-foreground-950">{h.heat}</b>
                      <span
                        className={`flex items-center gap-0.5 text-[11px] ${
                          h.trend === "up" ? "text-primary-600" : "text-foreground-400"
                        }`}
                      >
                        <i className={h.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                        {h.trend === "up" ? "上升" : "回落"}
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 分类索引 */}
          <div className="flex flex-col gap-5">
            <div className="border border-background-200 bg-foreground-950 p-5">
              <div className="flex items-center gap-2">
                <span className="h-5 w-1 bg-accent-500" />
                <h2 className="font-heading text-lg font-bold text-background-50">版块索引</h2>
              </div>
              <p className="mt-1 text-[11px] text-foreground-300">
                想直奔某一块，从这里进最快。实锤、时间线、复盘各有入口。
              </p>
              <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {sections.map((s) => (
                  <a
                    key={s.name}
                    href="#top"
                    className="group flex items-center gap-2.5 rounded-md border border-foreground-800 bg-foreground-900 px-3 py-2.5 transition-colors hover:border-accent-500/50"
                  >
                    <span className={`flex h-8 w-8 items-center justify-center rounded-md text-base ${s.tone}`}>
                      <i className={s.icon} />
                    </span>
                    <span className="flex flex-col leading-none">
                      <span className="text-sm font-semibold text-background-50">{s.name}</span>
                      <span className="mt-0.5 text-[10px] text-foreground-400">{s.count}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>

            <div className="flex flex-1 flex-col justify-between border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1 text-sm font-semibold text-foreground-950">
                  <i className="ri-flashlight-fill text-accent-600" /> 本周节奏
                </span>
                <span className="text-[11px] text-foreground-500">数据截至今日</span>
              </div>
              <ul className="mt-4 space-y-3 text-xs text-foreground-600">
                <li className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-primary-500" />
                  新增 实锤帖 14 帖，采纳 5 帖
                </li>
                <li className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-accent-500" />
                  时间线对齐 7 条长轴更新
                </li>
                <li className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-secondary-500" />
                  反转复盘 4 篇、澄清 3 条发布
                </li>
              </ul>
              <a
                href="#followup"
                className="mt-4 inline-flex items-center gap-1 text-sm font-semibold whitespace-nowrap text-primary-600 hover:text-primary-700"
              >
                去后续进展速报 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}